import { Component } from '@angular/core';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { GlobalComponent } from 'src/app/global-component';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { ClientListService } from 'src/app/core/services/list-services/client-list.service';
import { ContactListService } from 'src/app/core/services/list-services/contact-list.service';
import { UserListService } from 'src/app/core/services/list-services/user-list.service';
import { UserBaseModel } from 'src/app/core/models/members/user/user-base.model';
import { ClientBaseModel } from 'src/app/core/models/members/client/client-base-model';
import { ContactBaseModel } from 'src/app/core/models/contact/contact-base.model';
import { DomSanitizer } from '@angular/platform-browser';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { RequisitionListService } from 'src/app/core/services/list-services/requisition-list.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { Router } from '@angular/router';
import { RequisitionModel } from 'src/app/core/models/requisition/requisition.model';
import { environment } from 'src/environments/environment';
import { DefaultImageService } from 'src/app/core/services/default-image.service';

@Component({
  selector: 'app-multisearch',
  templateUrl: './multisearch.component.html',
  styleUrls: ['./multisearch.component.scss'],
  providers: [ClientListService, ContactListService, RequisitionListService, UserListService] //must declare these in provider so they are injected as independent new services, instead of defaulting to the singleton method in angular. For More info see: https://angular.io/guide/architecture-services and for how to do it:  https://angular.io/guide/dependency-injection
})

/**
 * This does not extend any other base component as its nto a modal or a list by itself, it is a collection of lists instead. 
 */
export class MultiSearchComponent {

  protected dropdownElement: any;

  //searchBar Variables 
  protected searchTerm: string = ``;
  protected minLengthTerm: number = GlobalComponent.minSearchLengthTerm;
  protected searchPlaceHolderText: string = $localize`:@@:Search`;

  protected clientListItems: ClientBaseModel[] = [];
  protected contactListItems: ContactBaseModel[] = [];
  protected requisitionListItems: RequisitionModel[] = [];
  protected userListItems: UserBaseModel[] = [];

  protected clientListLoading: boolean = false;
  protected contactListLoading: boolean = false;
  protected requisitionListLoading: boolean = false;
  protected userListLoading: boolean = false;

  protected securityPermissionClientSearch: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientManagement);
  protected securityPermissionContactSearch: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountManagement);
  protected securityPermissionRequisitionSearch: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionManagement);
  protected securityPermissionUserSearch: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userManagement);

  protected securityPermissionClientCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientCreate);
  protected securityPermissionContactCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountCreate);
  protected securityPermissionRequisitionCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreate);
  protected securityPermissionUserCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userCreate);

  entityTypeEnum = EntityTypeEnum;
  
  protected defaultImageService: DefaultImageService = new DefaultImageService();

  constructor(
    protected authMyFileService: AuthMyfileService,
    protected clientListService: ClientListService,
    protected contactListService: ContactListService,
    protected userListService: UserListService,
    protected requisitionListService: RequisitionListService,
    protected sanitizer: DomSanitizer,
    protected myFileApiService: MyfileApiService,
    protected openModalService: OpenModalService,
    protected toasterNotificationService: ToasterNotificationService,
    protected router: Router,
  ) {}

  ngOnInit(): void {

    if (this.securityPermissionClientSearch) {
      this.clientListService.loading$.subscribe((result) => {
        this.clientListLoading = result;
      });
      this.clientListService.resultItems$.subscribe((result) => {
        this.clientListItems = Object.assign([], result);
        this.clientListItems.forEach((clientModel) => {
          this.getEntityPhoto(clientModel, EntityTypeEnum.Client);
        })
      })
    }

    if (this.securityPermissionContactSearch) {
      this.contactListService.loading$.subscribe((result) => {
        this.contactListLoading = result;
      });
      this.contactListService.resultItems$.subscribe((result) => {
        this.contactListItems = Object.assign([], result);
        this.contactListItems.forEach((contactModel) => {
          this.getEntityPhoto(contactModel, EntityTypeEnum.Account);
        })
      })
    }

    if (this.securityPermissionRequisitionSearch) {
      this.requisitionListService.loading$.subscribe((result) => {
        this.requisitionListLoading = result;
      });
      this.requisitionListService.resultItems$.subscribe((result) => {
        this.requisitionListItems = Object.assign([], result);
        this.requisitionListItems.forEach((requisitionModel) => {
          this.getEntityPhoto(requisitionModel, EntityTypeEnum.Requisition);
        })
      })
    }

    if (this.securityPermissionUserSearch) {
      this.userListService.loading$.subscribe((result) => {
        this.userListLoading = result;
      });
      this.userListService.resultItems$.subscribe((result) => {
        this.userListItems = Object.assign([], result);
        this.userListItems.forEach((userModel) => { 
          this.getEntityPhoto(userModel, EntityTypeEnum.User);
        });
      });
    }
  }

  ngAfterViewInit() {
    this.dropdownElement = document.getElementById("search-dropdown") as HTMLAreaElement;
  }

  //this is the same code which is used in the BaseListWithEntityPhotosComponent
  getEntityPhoto(entity: any, entityTypeEnum: EntityTypeEnum) {
    if (entityTypeEnum == EntityTypeEnum.Requisition) {
      entity.listPhoto = GlobalComponent.defaultDocumentImageUrl;
      if (entity.id && entity.imageUrl) {
        entity.listPhoto = environment.staticImageApiUrl + entity.imageUrl.split('/').pop();;
      }
    } else {
      entity.listPhoto = this.defaultImageService.getDefaultUserImage(entity.fullName);
      if (entity.id && entity.profilePhotoFileId) {
        this.myFileApiService.getEntityFile(entityTypeEnum, entity.id, entity.profilePhotoFileId).subscribe(result => {
          if (result) {
            var reader = new FileReader();
            reader.readAsDataURL(result);
            reader.onload = () => {
              if (reader.result) {
                var sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
                entity.listPhoto = sanitizedUrl;
              }
            }
          }
        })
      }
    }
  }

  //this code block is taken 
  openModalNew(entityTypeEnum: EntityTypeEnum) {
    switch (entityTypeEnum) {
      case EntityTypeEnum.Account:
        this.openModalService.newContactModal(this.contactListService);
        break;
      case EntityTypeEnum.Client:
        this.openModalService.newClientModal(this.clientListService);
        break;
      case EntityTypeEnum.Requisition:
        this.router.navigateByUrl('/marketplace/explore')
        break;
      case EntityTypeEnum.User:
        if (this.authMyFileService.currentUserContextValue?.businessUnitId) {
          this.openModalService.newUserModal(this.authMyFileService.currentUserContextValue?.businessUnitId, this.userListService);
        } else {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
        }
        break;
    }
    this.clearSearch();
  }

  openModalEdit(entityTypeEnum: EntityTypeEnum, modelId: string | undefined) {
    if (modelId == undefined) {
      this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    } else {
      switch (entityTypeEnum) {
        case EntityTypeEnum.Account:
          this.openModalService.editContactModal(this.contactListService, modelId, undefined, undefined);
          break;
        case EntityTypeEnum.Client:
          this.openModalService.editClientModal(this.clientListService, modelId, undefined, undefined);
          break;
        case EntityTypeEnum.Requisition:
          this.openModalService.editRequisitionModal(this.clientListService, modelId);
          break;
        case EntityTypeEnum.User:
          if (this.authMyFileService.currentUserContextValue?.businessUnitId) {
            this.openModalService.editUserModal(modelId, this.authMyFileService.currentUserContextValue?.businessUnitId, this.userListService);
          } else {
            this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          }
          break;
      }
    }
    this.clearSearch();
  }

  clearSearch() {
    this.searchTerm = ``;
    this.dropdownElement.classList.remove("show");
  }

  search() {
    if (this.searchTerm.length >= this.minLengthTerm) {
      this.dropdownElement.classList.add("show");
      if (this.securityPermissionClientSearch) {
        this.clientListService.searchTerm = this.searchTerm;
      }
      if (this.securityPermissionContactSearch) {
        this.contactListService.searchTerm = this.searchTerm;
      }
      if (this.securityPermissionUserSearch) {
        this.userListService.searchTerm = this.searchTerm;
      }
      if (this.securityPermissionRequisitionSearch) {
        this.requisitionListService.searchTerm = this.searchTerm;
      }
    } else {
      this.dropdownElement.classList.remove("show");
    }
  }

  styleRowStatus(data: RequisitionModel): string {
    if (data.completedById) {
      return GlobalComponent.colorHexCodes.green;
    }
    if (data.incompletedById) {
      return GlobalComponent.colorHexCodes.red;
    }
    if (data.processedById) {
      return GlobalComponent.colorHexCodes.orange;
    }
    if (data.submittedById) {
      return GlobalComponent.colorHexCodes.blue;
    }
    return GlobalComponent.colorHexCodes.purple;
  }

}
